import Glide from '@glidejs/glide';

const TgeApp = {
    run: function () {
        this.initKeyboardEvents();
        this.initNewsListSlider();
        this.initNavigationButtons();
        this.initScrollToTop();
        this.initListClasses();
        this.initTgeMarineInFigures();
        this.initEventForm();
    },

    initNewsListSlider: function () {
        if (document.querySelector('.news-list-slider') === null) {
            return;
        }

        const glide = new Glide('.news-list-slider', {
            perView: 4,
            type: 'carousel',
            gap: 40,

            breakpoints: {
                575: {
                    perView: 1,
                },
                991: {
                    perView: 2,
                },
                1279: {
                    perView: 3,
                }
            }
        }).mount();
    },

    initKeyboardEvents: function () {
        document.addEventListener('keydown', function (event) {
            switch (event.code) {
                case 'Tab':
                    document.querySelector('html').classList.add('tab-nav');
                    break;
                case 'Escape':
                    const focus = <HTMLElement>document.querySelector('#mainmenu :focus');
                    if (focus !== null) {
                        focus.blur();
                    }
                    TgeApp.closeMainMenu();
                    break;
            }
        });
    },

    closeMainMenu: function () {
        const element = document.querySelector('#mainmenu').parentNode;
        element.querySelector('[aria-expanded]').setAttribute('aria-expanded', 'false');
        document.querySelector('body, html').classList.remove('no-scroll');
    },

    initNavigationButtons: function () {
        document.querySelector('#header button.menu-button, #header button.more')
            .addEventListener('click', (e) => {
                e.preventDefault();

                const element = <HTMLElement>e.target;

                if (element.className === 'menu-button') {
                    document.querySelector('body, html').classList.toggle('no-scroll');
                }

                element.setAttribute(
                    'aria-expanded',
                    element.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
                );
            });

        document.querySelector('body, html')
            .addEventListener('click', (e) => {
                const mainMenu = document.querySelector('#mainmenu').parentNode;
                const eventTarget = <Node>e.target;

                if (!mainMenu.contains(eventTarget)) {
                    TgeApp.closeMainMenu();
                }
            });
    },

    initScrollToTop: function () {
        const scrollTop = <HTMLElement>document.querySelector('#scroll-top');

        if (scrollTop === null) {
            return;
        }

        scrollTop.classList.add('hide');

        document.addEventListener('scroll', (e) => {
            if (window.scrollY >= 700) {
                scrollTop.classList.remove('hide');
                scrollTop.classList.add('show');
                return;
            }

            scrollTop.classList.remove('show');
            scrollTop.classList.add('hide');
        })
    },

    initListClasses: function () {
        document.querySelectorAll('#main li').forEach((li) => {
            if (li.className.indexOf('glide') !== -1) {
                return;
            }

            const parentNode = <HTMLElement>li.parentNode;
            if (parentNode.className !== '') {
                return;
            }

            parentNode.classList.add('has-' + li.className);
        });
    },

    initTgeMarineInFigures: function () {
        const mainElement = document.querySelector('.tge-marine-in-figures');
        if (mainElement === null) {
            return;
        }

        const elements = mainElement.querySelectorAll('.number');
        const firstElement = <HTMLElement>elements[0];
        const firstElementNumber = parseInt(firstElement.innerHTML);

        const observer = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) {
                return;
            }

            TgeApp.animateNumberInItem(firstElementNumber, firstElement, 1);
            elements.forEach((element: HTMLElement, index: number) => {
                if (index === 0) {
                    return;
                }
                const currentElementNumber = parseInt(element.innerHTML);
                const ratio = currentElementNumber / firstElementNumber;

                TgeApp.animateNumberInItem(parseInt(element.innerHTML), element, ratio);
            });

            observer.unobserve(mainElement);
        });

        observer.observe(mainElement);
    },

    animateNumberInItem: function (number: number, item: HTMLElement, ratio: number) {
        let startingNumber = 0;
        const animationSpeed = 30;

        const interval = setInterval(() => {
            startingNumber += ratio;

            if (startingNumber >= number) {
                item.innerHTML = number.toString();
                clearInterval(interval);
                return;
            }

            item.innerHTML = Math.round(startingNumber).toString();

        }, animationSpeed);
    },

    initEventForm: function () {
        const eventForm = document.querySelector('form[id^="event-"]');
        if (eventForm === null) {
            return;
        }

        const textarea = eventForm.querySelector('textarea').parentElement.parentElement;
        textarea.style.display = 'none';
        const checkbox = eventForm.querySelector('input[value="Other"]');
        checkbox.addEventListener('change', function () {
            textarea.style.display = this.checked ? 'block' : 'none';
        });
    }
}

TgeApp.run();
